import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { diagnosticService } from '../services';
import type { BlindSpotListFilter } from '../types';

export function useRuntimeBlindSpotsSummary() {
  return useQuery({
    queryKey: ['diagnostic', 'blindSpots', 'summary'],
    queryFn: () => diagnosticService.getRuntimeBlindSpotsSummary(),
  });
}

export function useRuntimeBlindSpotsList(filter?: BlindSpotListFilter) {
  return useQuery({
    queryKey: ['diagnostic', 'blindSpots', 'list', filter],
    queryFn: () => diagnosticService.getRuntimeBlindSpotsList(filter),
  });
}

export function useRecalculateBlindSpots() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => diagnosticService.recalculateBlindSpots(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['diagnostic', 'blindSpots'] });
    },
  });
}
